import CrmContact from "../model"

export default class CrmContactAccessControl {

    private contact : CrmContact

    constructor(contact:CrmContact) {
        this.contact = contact
    }

    get canEdit(): boolean {
        return gd.ac.check.company.canEditCustomers()
    }

    get canChangeCustomFields(): boolean {
        return this.canEdit
    }
}
